import React, { useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
// import DatePicker from "../components/DatePicker"
import MenuList from "../components/MenuList"

import moment from "moment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import FoodTypeSelector from "../components/FoodTypeSelector"
import RestaurantSelector from "../components/RestaurantSelector"

const IndexPage = () => {
  const data = useStaticQuery(
    graphql`
      query MyQuery {
        wpgraphql {
          allRestaurantsMetadata(last: 50) {
            nodes {
              title
              slug
              id
              allCitiessMetadata {
                nodes {
                  name
                  slug
                }
              }
              allFoodTypessMetadata(where: { orderby: TERM_ID }) {
                nodes {
                  name
                  slug
                }
              }
              restaurantACF {
                address
                available
                ongoinMenus {
                  date
                  dateDeDebut
                  dateDeFin
                  desserts
                  plats
                  starters
                }
                opening {
                  dimanche
                  jeudi
                  lundi
                  mardi
                  mercredi
                  samedi
                  vendredi
                }
                optionPlatSeul
                pageFacebook
                phone
                siteWeb
                tarifs {
                  tarifEntreePlatDessert
                  tarifEntreePlatOuPlatDessert
                  tarifPlatSeul
                }
                typeDeMenu
              }
            }
          }
          terms(where: { taxonomies: FOODTYPEMETADATA }) {
            nodes {
              name
              slug
            }
          }
          pageBy(id: "cG9zdDoxNzE=") {
            featuredImage {
              node {
                title(format: RENDERED)
                sourceUrl
                imageFile {
                  childImageSharp {
                    fixed(width: 1200, height: 600) {
                      src
                      width
                      height
                    }
                    resize(width: 900, quality: 90) {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  const [allMenus, setAllMenus] = useState(
    data.wpgraphql.allRestaurantsMetadata.nodes
  )
  const [currentDate, setCurrentDate] = useState(moment())
  const [selectedFoodType, setSelectedFoodType] = useState("")
  const [selectedRestaurant, setSelectedRestaurant] = useState("")
  // const handleDateChange = function (e) {
  //   e.preventDefault()
  //   setCurrentDate(moment(e.target.value))
  // }
  const handleFoodTypeChange = function (e) {
    setSelectedFoodType(e.target.value)
  }
  const handleRestaurantChange = function (e) {
    setSelectedRestaurant(e.target.value)
  }

  const foodTypes = data.wpgraphql.terms.nodes

  const featuredImage = data.wpgraphql.pageBy.featuredImage

  let metaFeatured = ""

  if (featuredImage && featuredImage !== null) {
    metaFeatured = featuredImage.node.imageFile.childImageSharp.resize.src
  }

  return (
    <Layout>
      <SEO title="Mes plats du jour" metaFeatured={metaFeatured} />
      <div className="grid-container">
        <section className="section section--small">
          <h1 className="h2">
            Trouvez à Strasbourg le restaurant qui propose la meilleure formule
            déjeuner, menu de la semaine, entrée, plat, dessert, ou simplement
            le meilleur plat du jour.
          </h1>
          {/* <h2 className="h4">
            Découvrez les plats du jour, formules déjeuner et bons plans des
            restaurants de votre quartier.
          </h2> */}
          <p className="">
            Un repas avec vos collègues ce midi ? Vous cherchez votre plat du
            jour, ou alors une formule entrée, plat, dessert ? En un seul click
            trouvez l'offre la plus intéressante du quartier et réservez votre
            restaurant.
          </p>
          <div className="front--covid text-center">
            <div className="h1 mt-2 mb-2">
              L'application Mes plats du jour est en vacances
            </div>
            <div className="h3">
              Nous arrêtons les mises à jour de menus pendant les fêtes retour
              fin aout !!
              <br />
              Bonnes vacances et bon été à tous !
            </div>
          </div>
          {/* <div className="front--covid">

            <h2 className="h3 primary">Pour raison évidente de confinement lié au Covid-19, nous ne mettons plus à jour les menus et formules du jour des restaurants Strasbourgeois</h2>
            <h3 className="h4 primary-dark">Vous trouverez ci dessous une liste non exhaustive de restaurants qui proposent des menus à emporter ou click and collect à Strasbourg.</h3>
            <h3 className="h4  primary">Vous aimez les restos de votre quartier ? Aidez-les à surmonter cette période difficile !</h3>
            <ul>
              <li><a href="http://les-garnements.fr/">Les Garnements</a></li>
              <li><a href="https://le-banquet.com/">Le Banquet des Sophistes</a></li>
              <li><a href="https://www.la-casserole.fr/">La Casserole</a></li>
              <li><a href="http://les-innocents.fr/">Les Innocents</a></li>
              <li><a href="https://restaurant-colbert.com/">Restaurant Colbert</a></li>
              <li><a href="https://lavignette.bonkdo.com/fr/clickandcollect/customization/633/">La Vignette Robertsau</a></li>
              <li><a href="https://buerehiesel.shop-and-go.fr/">Le Bueheriesel</a></li>
              <li><a href="https://commands.zenchef.com/items?rid=348895&fullscreen=&withCloseButton=1">Piano Grill</a></li>
              <li><a href="https://www.legrillon-restaurant.com/menu-semaine/">Le Grillon</a></li>
              <li><a href="https://www.restaurant-le-bistronome.com/d%C3%A9jeuner-%C3%A0-emporter/">Le Bistronome</a></li>
              <li><a href="https://lemuns.fr/">Le Munster</a></li>
              <li><a href="https://cafe-bretelles.fr/shop?fbclid=IwAR17roCKaQ_WYqsqbvDQtSExoq-sH8oKMM6T9yg5rDL5TXXXDJc602s1bkY">Café Bretelles</a></li>
              <li><a href="https://www.facebook.com/restaurantlesfunambules">Les Funambules</a></li>
              <li><a href="https://lebotanistealamaison.fr/">Le Botaniste</a></li>
              <li><a href="http://www.lebistrotdantoine.com/">Le Bistrot d'Antoine</a></li>
              <li><a href="https://www.cote-lac.com/menu-traiteur-a-emporter/">Côté Lac</a></li>
              <li><a href="https://www.facebook.com/lagrossebaloche">La Grosse Baloche</a></li>
              <li><a href="https://www.facebook.com/Heymama.Strasbourg/app/701720909911837">Hey Mama</a></li>
              <li><a href="https://www.pacodemaria.fr/">Paco de Maria</a></li>
              <li><a href="http://cheznousstrasbourg.com/">Chez Nous</a></li>
            </ul>
            <h3 className="primary mb-2">Votre restaurant préféré propose des formules à emporter mais n'est pas dans cette liste ? Envoyez nous le lien via notre formulaire de contact</h3>
            <Link
              className="button primary"
              to="/contact"
            >
              Contacter
            </Link>
          </div> */}
        </section>
        <section>
          <div className="full-width bg-light">
            <div className="grid-container">
              <div className="section section--small">
                <div className="search--container">
                  <div className="search--item">
                    <FoodTypeSelector
                      foodTypes={foodTypes}
                      onChange={handleFoodTypeChange}
                      selectedFoodType={selectedFoodType}
                    />
                  </div>
                  <div className="search--item">
                    <RestaurantSelector
                      onChange={handleRestaurantChange}
                      selectedRestaurant={selectedRestaurant}
                    />
                    {/* <DatePicker
                      currentDate={currentDate.format("YYYY-MM-DD")}
                      onChange={handleDateChange}
                      minDate={moment().format("YYYY-MM-DD")}
                    ></DatePicker> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <MenuList
            currentDate={currentDate}
            allMenus={allMenus}
            selectedFoodType={selectedFoodType}
            selectedRestaurant={selectedRestaurant}
          />
          {/* <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
        <Image />
      </div> */}
        </section>
      </div>
      <section className="section section--small bg-light">
        <div className="grid-container">
          <p>
            <strong>Note importante :</strong> Actuellement, nous récupérons les
            informations manuellement depuis les sites internets ou pages web
            des restaurants listés. Certaines informations peuvent être
            erronnées de notre fait si nous avons raté une mise à jour du
            restaurateur, ou si le restaurateur n'a lui même pas mis à jour son
            site web ou sa page facebook. N'étant pas rémunéré dans le cadre de
            ce site internet, nous vous remerions de votre compréhension en cas
            d'incohérence.
          </p>
          <p>
            Notre objectif à terme est que les restaurateurs entrent eux même
            leurs informations et menus dans notre système
          </p>
          <p>
            Il peut arriver que des restaurants ferment ponctuellement pour
            cause de congés, jours, fériés, corona virus etc... Nous vous
            invitons à vérifier systématiquement que le restaurant dans lequel
            vous voulez vous rendre est effectivement ouvert. Le numéro de
            téléphone et le site web de chaque restaurant est disponible en
            cliquant sur "Voir le restaurant".
          </p>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
